<template>
  <div class="lock-wrapper">
    <div class="button-wrapper">
      <TNote style="max-width: 190px; text-align: center">{{
        $t("forms.block_locked")
      }}</TNote>

      <t-button
        data-testid="unlock-block-button"
        disabled
        style="margin-top: 12px"
        @click="unlock"
      >
        <template #icon>
          <svg
            class="icon-style"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
        </template>
        {{ $t("forms.unlock_block") }}
      </t-button>
    </div>

    <div class="locked">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { TButton, TNote } from "@topol/twig-ui";
  import { useMjmlStore } from "@/stores/mjmlStore";

  const mjmlStore = useMjmlStore();

  const unlock = function () {
    mjmlStore.toggleBlockLock();
  };
</script>

<style>
  .lock-wrapper {
    position: relative;
    justify-content: center;
  }

  .button-wrapper {
    position: absolute;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    top: 64px;
  }

  .icon-style {
    width: 20px;
    height: 20px;
  }

  .locked {
    background-color: var(--c-g700);
    opacity: 0.05;
    padding-top: 0px;
    z-index: -1;
    height: 100%;
    pointer-events: none;
    display: flex;
    justify-content: center;
  }
</style>
